import { ZendeskWidgetContext } from './ZendeskWidgetContext';
import { useProviderHelp } from './useHelp';

const ZendeskHelpContainer = ({ children }: { children: React.ReactNode }) => {
  const helpValue = useProviderHelp();
  return (
    <ZendeskWidgetContext.Provider value={helpValue}>{children}</ZendeskWidgetContext.Provider>
  );
};

export default ZendeskHelpContainer;
